import { ACCEPTED_IMAGE_TYPES } from '../../model/consts';

export const isRejectedImageDrag = (items: DataTransferItemList) => {
    const fileItems = Array.from(items).filter((item) => item.kind === 'file');

    return fileItems.some((item) => item.type && !ACCEPTED_IMAGE_TYPES.includes(item.type));
};
